export const GOOGLE_MAP_ZOOM = 17

export const GOOGLE_MAP_CENTER = {
  lat: 48.210033,
  lng: 16.363449,
}

export const GOOGLE_MAP_ID = 'google-map-id-0'
